module.exports = __webpack_public_path__ + "static/media/friargate-4.dbdc9d18.jpg";